/* eslint-disable */
import * as Types from './types';

export type CustomerWishlistFragment = { __typename?: 'Customer', wishlistProducts?: { __typename?: 'Metafield', value: string, id: string } | null, wishlistNailArt?: { __typename?: 'Metafield', value: string, id: string } | null, wishlistArticles?: { __typename?: 'Metafield', value: string, id: string } | null };

export declare const CustomerWishlistFragment: import("graphql").DocumentNode;
export const CustomerWishlistFragmentDoc = /*#__PURE__*/ `
    fragment CustomerWishlistFragment on Customer {
  wishlistProducts: metafield(namespace: "wishlist", key: "products") {
    value
    id
  }
  wishlistNailArt: metafield(namespace: "wishlist", key: "nailArt") {
    value
    id
  }
  wishlistArticles: metafield(namespace: "wishlist", key: "articles") {
    value
    id
  }
}
    `;